import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* The two redirect URLs are not cosmetic - without them a modal sign-in
        completes and then strands the user.

        Observed on the live production instance: sign-in succeeded, the session
        was created and marked active on the client, and Clerk never adopted it -
        window.Clerk.session and .user both stayed null while
        client.sessions[0].status was "active". In that state <SignedIn> sees no
        user and <SignedOut> sees a live session, so BOTH render nothing: the
        intake card lost its button and the nav lost My Account, which reads as
        two bugs and is one. Calling setActive by hand fixed it instantly, which
        is what identified the gap.

        A production instance with no redirect configured falls back to the
        Account Portal on accounts.<domain>, which is a hostname whose certificate
        is issued separately and later - so the completion step depended on
        infrastructure that has nothing to do with signing in. Naming our own
        destination keeps the whole flow on this origin.

        afterSignInUrl / afterSignUpUrl are the deprecated spelling; these are the
        v5 props. */}
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
    >
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ClerkProvider>
  </React.StrictMode>,
);
